import { OnInit, Input, Component } from '@angular/core';

@Component({
    selector: 'app-item-header',
    templateUrl: './item-header.component.html',
    styleUrls: ['./item-header.component.scss'],
    standalone: false
})
export class ItemHeaderComponent implements OnInit {

  @Input() loading: boolean;
  @Input() title: string;
  @Input() content: string;
  ngOnInit() {
  }
}
